export const { location } = globalThis;
